<ion-app class="glass-morphism">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
